/**
 * Shared tenant-visibility filter for global_admin tenant dropdowns.
 *
 * Hides review sandbox accounts (is_reviewer) and inactive/suspended accounts (subscription_status 'canceled' or 'suspended')
 * while preserving tenants with null / 'active' / 'trialing' status. A naive
 * `.not('subscription_status','in','(canceled,suspended)')` would WRONGLY drop
 * null-status real customers (e.g. Goosehead) because `NULL NOT IN (...)` is NULL,
 * not TRUE — so we use an explicit OR that keeps NULL.
 *
 * CommonJS so it can be `require`d by the Express api_routes AND imported by the
 * CRA/webpack client (same interop as src/lib/supabaseClient.js).
 *
 * Usage:
 *   const { VISIBLE_TENANTS_OR } = require('../lib/tenantVisibility');
 *   supabase.from('tenants').select('id, name').or(VISIBLE_TENANTS_OR)
 * or:
 *   excludeInactiveTenants(supabase.from('tenants').select('id, name'))
 */
const HIDDEN_TENANT_STATUSES = ['canceled', 'suspended'];

// PostgREST .or() expression (string passed to supabase `.or(...)`).
// Also hides review sandbox tenants (tenants.is_reviewer): outside evaluators' accounts are never real
// customers, so they must not appear in any admin dropdown, health table or report. Wrapped in one and()
// because a PostgREST .or() cannot AND a second column. Verified 2026-09-27: identical rows to the
// previous filter while no reviewer exists.
const VISIBLE_TENANTS_OR =
  'and(is_reviewer.eq.false,or(subscription_status.is.null,and(subscription_status.neq.canceled,subscription_status.neq.suspended)))';

/** Apply the active-tenant filter to a supabase query builder; returns the builder. */
function excludeInactiveTenants(query) {
  return query.or(VISIBLE_TENANTS_OR);
}

module.exports = { HIDDEN_TENANT_STATUSES, VISIBLE_TENANTS_OR, excludeInactiveTenants };
